import { render, staticRenderFns } from "./services-meb.vue?vue&type=template&id=04550d35&scoped=true&"
import script from "./services-meb.vue?vue&type=script&lang=js&"
export * from "./services-meb.vue?vue&type=script&lang=js&"
import style0 from "./services-meb.vue?vue&type=style&index=0&id=04550d35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04550d35",
  null
  
)

export default component.exports